import { CardDataList } from "@components/CardDataList/CardDataList"
import { useCasesAddressSerializer } from "./utils/casesAddressSerializerSchema"

export const EditCasesAddress = ({
  refund_address_guid,
  prospect_guid,
  handleUpdateCaseAttribute,
}: {
  refund_address_guid: string
  prospect_guid: string
  handleUpdateCaseAttribute: (address_guid: string) => void
}) => {
  const { data: casesAddressData, isError: casesAddressIsError } =
    useCasesAddressSerializer({
      refund_address_guid,
      prospect_guid,
      handleUpdateCaseAttribute,
    })
  return (
    <CardDataList
      items={casesAddressData.items}
      isError={casesAddressIsError}
    />
  )
}
